<div class="mcm-metric-detail-sub-header">
  @if (subHeader()?.imageB || subHeader()?.textB) {
    <div class="mcm-metric-detail-sub-header__comparison-view">
      <div
        class="mcm-metric-detail-sub-header__comparison-view-item mcm-metric-detail-sub-header__comparison-view-item--left">
        <img
          loading="lazy"
          [srcUrl]="subHeader()?.imageA"
          [mcuiDefaultImage]="subHeader()?.placeholderA"
          class="mcm-metric-detail-sub-header__logo"
          [ngClass]="subHeader()?.imageAStyleClass"
          alt="{{ subHeader()?.textA }}" />
        <span class="mcm-metric-detail-sub-header__comparison-view-item-text">{{ subHeader()?.textA }}</span>
      </div>

      <div
        class="mcm-metric-detail-sub-header__comparison-view-item mcm-metric-detail-sub-header__comparison-view-item--right">
        <img
          loading="lazy"
          [srcUrl]="subHeader()?.imageB"
          [mcuiDefaultImage]="subHeader()?.placeholderB"
          class="mcm-metric-detail-sub-header__logo"
          [ngClass]="subHeader()?.imageBStyleClass"
          alt="{{ subHeader()?.textB }}" />
        <span class="mcm-metric-detail-sub-header__comparison-view-item-text">{{ subHeader()?.textB }}</span>
      </div>
    </div>
  } @else if (subHeader()?.numberA) {
    <div class="mcm-metric-detail-sub-header__single-view">
      <img
        loading="lazy"
        [srcUrl]="subHeader()?.imageA"
        [mcuiDefaultImage]="subHeader().placeholderA"
        class="mcm-metric-detail-sub-header__avatar"
        [ngClass]="subHeader()?.imageAStyleClass"
        alt="{{ subHeader()?.textA }}" />
      @if (subHeader()?.secondaryImageA) {
        <img
          loading="lazy"
          [srcUrl]="subHeader()?.secondaryImageA"
          [mcuiDefaultImage]="subHeader()?.secondaryPlaceholderA"
          class="mcm-metric-detail-sub-header__logo--secondary"
          alt="" />
      }
      <span class="mcm-metric-detail-sub-header__number">{{ subHeader()?.numberA }}</span>
      <div class="mcm-metric-detail-sub-header__info">
        <span class="mcm-metric-detail-sub-header__info-name">{{ subHeader()?.textA }}</span>
        <span class="mcm-metric-detail-sub-header__info-position">{{
          subHeader()?.positionData | demarcation: playerDemarcationKeys : playerDemarcationFallbackKey : ' '
        }}</span>
      </div>
    </div>
  } @else {
    <div class="mcm-metric-detail-sub-header__single-view">
      <img
        loading="lazy"
        [srcUrl]="subHeader()?.imageA"
        [mcuiDefaultImage]="subHeader()?.placeholderA"
        [ngClass]="subHeader()?.imageAStyleClass"
        class="mcm-metric-detail-sub-header__logo"
        alt="{{ subHeader()?.textA }}" />
      <span class="mcm-metric-detail-sub-header__text">{{ subHeader()?.textA }}</span>
    </div>
  }
</div>
